module.exports = __webpack_public_path__ + "static/media/TableTopLoyaltyScreen.677febe7.png";